/** Spanish UI strings. Add `en.ts` with the same shape to translate. */
export const es = {
  app: { name: "TopSummits", tagline: "Mi pasaporte de cimas" },
  tabs: { explore: "Explorar", map: "Mapa", peaks: "Cimas", ascents: "Ascensiones", lists: "Listas", passport: "Pasaporte", me: "Tú", navigation: "Principal", friends: "Amigos" },
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    close: "Cerrar",
    done: "Hecho",
    add: "Añadir",
    back: "Atrás",
    search: "Buscar",
    loading: "Cargando…",
    retry: "Reintentar",
    confirm: "Confirmar",
    more: "Más",
    none: "Ninguno",
    all: "Todas",
    yes: "Sí",
    no: "No",
    m: "{n} m",
    km: "{n} km",
    offline: "Sin conexión",
    error: "Algo ha fallado",
    notFound: "No encontrado",
    optional: "opcional",
    share: "Compartir",
    clear: "Limpiar",
    apply: "Aplicar",
    showAll: "Ver todo",
    select: "Seleccionar",
    attribution: "Atribución",
    openInNew: "Abrir",
  },
  activity: {
    senderismo: "Senderismo",
    alpinismo: "Alpinismo",
    esqui_montana: "Esquí de montaña",
    raquetas: "Raquetas",
    escalada: "Escalada",
    via_ferrata: "Vía ferrata",
  },
  season: { invierno: "Invierno", primavera: "Primavera", verano: "Verano", otono: "Otoño" },
  priority: { 1: "Alta", 2: "Media", 3: "Baja" },
  stats: {
    ascents: "Ascensiones",
    uniquePeaks: "Cimas",
    threeThousanders: "Tresmiles",
    gainThisYear: "Desnivel {year}",
    title: "Estadísticas",
    perYear: "Por año",
    gainPerYear: "Desnivel por año",
    topMassifs: "Macizos más visitados",
    listProgress: "Progreso de listas",
    byActivity: "Por actividad",
    noData: "Aún no hay datos. ¡Registra tu primera ascensión!",
    highest: "Cima más alta",
    totalGain: "Desnivel total",
    totalDistance: "Distancia total",
    since: "Desde {date}",
    emptyTitle: "Aún no hay estadísticas",
    emptyBody: "Registra tu primera ascensión con el botón + y aquí verás tus totales.",
  },
  map: {
    title: "Mapa",
    recent: "Recientes",
    noRecent: "Aún no has registrado ascensiones.",
    layers: "Capas",
    overlays: "Mostrar",
    climbed: "Cimas ascendidas",
    bucket: "Cimas en listas",
    wish: "Bucket list",
    catalog: "Catálogo (zoom)",
    locate: "Mi ubicación",
    fullscreen: "Pantalla completa",
    exitFullscreen: "Salir de pantalla completa",
    tapToAdd: "Mantén pulsado el mapa para crear una cima",
    loadError: "No se pudo cargar el mapa",
    statsLabel: "Estadísticas: {ascents} ascensiones, {peaks} cimas, {three} tresmiles",
    topoMap: "Mapa topográfico",
    topoNote: "De lejos, solo el relieve. El mapa topográfico aparece al acercarte.",
    baseNote: {
      "ign-es": "Vertiente española, toponimia oficial",
      otm: "Todo el Pirineo, nombres locales",
      "ign-fr": "Vertiente francesa",
    },
    recentsEmpty: "Sin ascensiones todavía",
    recentsEmptyHint: "Pulsa + para registrar la primera",
    pendingSync: "Pendiente de sincronizar",
    logShort: "Registrar",
    statusClimbedOnce: "Ascendida el {date}",
    statusClimbed: "Ascendida {n} veces, la última el {date}",
    statusNotClimbed: "Sin ascender",
    customName: "Nombre",
    customElevation: "Altitud",
    customRequired: "Obligatorio",
    customOptional: "Opcional",
    customDistance: "A {n} m",
    customCoords: "Coordenadas {coords}",
    customCreated: "Cima creada",
    worldImportFailed: "No se pudo abrir {name}. Necesitas conexión.",
    filter: "Filtrar",
    filterTitle: "Filtrar cimas",
    filterStatus: "Estado",
    filterAll: "Todas",
    filterClimbed: "Ascendidas",
    filterPending: "Pendientes",
    filterAltitude: "Altitud",
    filterAnyAltitude: "Cualquier altitud",
    filterFrom: "Desde {min} m",
    filterTo: "Hasta {max} m",
    filterBetween: "De {min} a {max} m",
    filterMin: "Altitud mínima",
    filterMax: "Altitud máxima",
    filterTresmiles: "Tresmiles",
    filterList: "Lista",
    filterAnyList: "Todas las cimas",
    filterSector: "Sector",
    filterAllSectors: "Todo el Pirineo",
    filterWorld: "Mis cimas en el mundo",
    filterSectorCount: "{done} de {total}",
    filterSectorEmpty: "Ninguna",
    filterShow: "Ver {n} cimas",
    filterShowOne: "Ver 1 cima",
    filterShowNone: "Ninguna cima",
    filterReset: "Restablecer",
    filterClear: "Quitar filtros",
    filterEdit: "Cambiar filtros",
    filterHint: "Filtra por estado, altitud o lista, o céntrate en un sector. Los números cuentan las cimas que ves en el mapa.",
    sectorGroup: {
      occidental: "Pirineo occidental",
      central: "Pirineo central",
      oriental: "Pirineo oriental",
      prepirineo: "Prepirineo",
    },
  },
  peak: {
    elevation: "Altitud",
    prominence: "Prominencia",
    coordinates: "Coordenadas",
    massif: "Macizo",
    country: "País",
    altNames: "Otros nombres",
    wikipedia: "Wikipedia",
    myAscents: "Mis ascensiones",
    noAscents: "Aún no la has subido.",
    inLists: "En listas",
    noLists: "No está en ninguna lista.",
    logAscent: "Registrar ascensión",
    addToList: "Añadir a lista",
    refresh: "Actualizar desde la fuente",
    refreshed: "Datos actualizados",
    source: "Fuente",
    sources: { osm: "OpenStreetMap", wikidata: "Wikidata", custom: "Personalizada" },
    lastSynced: "Actualizada {date}",
    climbed: "Ascendida",
    pending: "Pendiente",
    firstAscent: "Primera ascensión {date}",
    timesClimbed: "{n} ascensiones",
    timesClimbedOne: "1 ascensión",
    newCustom: "Nueva cima",
    customName: "Nombre de la cima",
    customElevation: "Altitud (m)",
    createCustom: "Crear cima",
    similarNearby: "¿Es alguna de estas?",
    detailTitle: "Cima",
    openDetail: "Ver ficha",
    image: "Imagen",
    osmLink: "Ver en OpenStreetMap",
    wikidataLink: "Ver en Wikidata",
    climbedTimes: "Ascendida {n} veces",
    sourcesTitle: "Fuentes",
    copyCoordinates: "Copiar coordenadas",
    coordinatesCopied: "Coordenadas copiadas",
    notFoundTitle: "Cima no encontrada",
    notFoundBody: "Puede que el enlace no sea correcto o que la cima ya no exista.",
    offlineBody: "Esta cima no está guardada en el dispositivo. Vuelve a intentarlo con conexión.",
    loadError: "No se pudo cargar la ficha de la cima.",
    markDone: "Marcar como hecha",
    logAnother: "Añadir",
    inListsCount: "En {n} listas",
    inListsCountOne: "En 1 lista",
    alsoClimbed: "En la misma salida:",
  },
  ascents: {
    title: "Ascensiones",
    searchPlaceholder: "Buscar cima, ruta o notas",
    empty: "No hay ascensiones que coincidan.",
    emptyAll: "Todavía no has registrado ninguna ascensión.",
    count: "{n} ascensiones",
    countOne: "1 ascensión",
    filters: "Filtros",
    sort: "Ordenar",
    year: "Año",
    activity: "Actividad",
    difficulty: "Dificultad",
    massif: "Macizo",
    elevationRange: "Altitud de la cima",
    min: "Mín.",
    max: "Máx.",
    only3000: "Solo tresmiles",
    clearFilters: "Quitar filtros",
    sortBy: {
      date: "Fecha",
      elevation: "Altitud de la cima",
      gain: "Desnivel",
      duration: "Duración",
      difficulty: "Dificultad",
      name: "Nombre",
    },
    asc: "Ascendente",
    desc: "Descendente",
    newTitle: "Nueva ascensión",
    editTitle: "Editar ascensión",
    detailTitle: "Ascensión",
    deleteConfirm: "¿Eliminar esta ascensión? No se puede deshacer.",
    deleted: "Ascensión eliminada",
    saved: "Ascensión guardada",
    savedOffline: "Guardada sin conexión. Se sincronizará al recuperar cobertura.",
    winter: "Invernal",
    emptyTitle: "Aún no hay ascensiones",
    emptyBody: "Registra tu primera cima y aparecerá aquí.",
    noMatches: "Sin resultados",
    countOf: "{n} de {total} ascensiones",
    order: "Orden",
    resetFilters: "Restablecer",
    from: "Desde",
    to: "Hasta",
    noLimit: "Sin límite",
    allMassifs: "Todos",
    delete: "Eliminar ascensión",
    pendingSync: "Pendiente de sincronizar",
    conditions: "Condiciones",
    rating: "Valoración: {n} de 5",
    notFoundBody: "Puede que se haya eliminado.",
    backToList: "Ver ascensiones",
  },
  form: {
    peaks: "Cimas",
    addPeak: "Añadir cima",
    peakSearch: "Buscar cima (aneto, pica d estats…)",
    noCatalogResults: "Ninguna cima de tu catálogo coincide.",
    searchOnline: "Buscar «{q}» en línea",
    searchOnlineHint: "OpenStreetMap y Wikidata",
    searchingOnline: "Buscando en línea…",
    onlineResults: "En línea",
    noOnlineResults: "Sin resultados en línea",
    onlineAllInCatalog: "Lo encontrado en línea ya está en tu catálogo.",
    atSummit: "Estoy en la cima",
    locating: "Buscando tu posición…",
    nearestPeaks: "Cimas cercanas",
    accuracy: "Precisión ±{n} m",
    noNearby: "No hay cimas del catálogo cerca.",
    locationDenied: "No se pudo obtener tu ubicación.",
    date: "Fecha",
    startTime: "Hora de inicio",
    duration: "Duración total",
    timeToSummit: "Tiempo hasta la cima",
    hours: "h",
    minutes: "min",
    gain: "Desnivel positivo (m)",
    distance: "Distancia (km)",
    gainShort: "Desnivel",
    distanceShort: "Distancia",
    durationShort: "Duración",
    activity: "Actividad",
    sac: "Escala SAC",
    alpine: "Graduación alpina",
    difficultyNotes: "Dificultad (texto libre)",
    route: "Ruta",
    startPoint: "Punto de inicio",
    winter: "Ascensión invernal",
    conditions: "Condiciones (tiempo, nieve…)",
    companions: "Compañeros",
    rating: "Valoración",
    notes: "Notas",
    externalUrl: "Enlace (Strava, Wikiloc…)",
    routeLink: "Enlace de Wikiloc o Strava",
    routeLinkHint: "Pega el enlace de la ruta en Wikiloc o, si no, de la actividad en Strava.",
    routeLinkInvalid: "Ese enlace no es de Wikiloc ni de Strava.",
    paste: "Pegar",
    removeRoute: "Quitar ruta",
    more: "Más opciones",
    none: "Sin indicar",
    gpx: "Track GPX",
    addGpx: "Añadir GPX",
    removeGpx: "Quitar GPX",
    required: "Obligatorio",
    needPeak: "Añade al menos una cima",
    sections: {
      summit: "Cima",
      when: "Cuándo",
      how: "Cómo",
      difficulty: "Dificultad",
      details: "Detalles",
      route: "Ruta",
    },
    discardConfirm: "¿Descartar los cambios?",
    removePeak: "Quitar {name}",
    stars: "{n} estrellas",
    starsOne: "1 estrella",
  },
  route: {
    wikiloc: "Wikiloc",
    strava: "Strava",
    link: "Enlace",
    untitled: "Ruta",
  },
  lists: {
    title: "Listas",
    empty: "Crea tu primera lista de cimas pendientes.",
    new: "Nueva lista",
    name: "Nombre",
    description: "Descripción",
    rename: "Renombrar",
    deleteConfirm: "¿Eliminar la lista «{name}»? Las cimas y ascensiones no se borran.",
    progress: "{done} / {total}",
    progressLabel: "{done} de {total} completadas",
    curated: "Lista curada",
    approximate: "Aproximada",
    source: "Fuente: {source}",
    licence: "Licencia: {licence}",
    reorder: "Ordenar listas",
    moveUp: "Subir",
    moveDown: "Bajar",
    pending: "Pendientes",
    done: "Hechas",
    all: "Todas",
    sortBy: { priority: "Prioridad", elevation: "Altitud", distance: "Distancia", massif: "Macizo", position: "Orden" },
    distanceNeedsLocation: "Activa la ubicación para ordenar por distancia",
    addPeaks: "Añadir cimas",
    addFromCatalog: "Buscar en el catálogo",
    addFromLive: "Búsqueda en línea",
    addFromMap: "Desde el mapa",
    addFromView: "Todas las cimas de la vista",
    importFile: "Importar CSV / GPX",
    minElevation: "Por encima de (m)",
    addNPeaks: "Añadir {n} cimas",
    addedN: "{n} cimas añadidas",
    alreadyIn: "Ya está en la lista",
    itemTitle: "Cima en la lista",
    targetSeason: "Temporada objetivo",
    targetYear: "Año objetivo",
    plannedRoute: "Ruta prevista",
    notes: "Notas",
    priority: "Prioridad",
    removeFromList: "Quitar de la lista",
    showMap: "Mapa",
    showList: "Lista",
    importHelp: "CSV con columnas nombre, lat, lon (y opcional altitud) o un GPX con waypoints. Cada punto se empareja con la cima más cercana del catálogo (≤ 200 m).",
    importResult: "{matched} emparejadas, {missing} sin emparejar",
    pickList: "Elige una lista",
    addedTo: "Añadida a «{name}»",
    viewTooLarge: "Acerca el mapa para añadir las cimas de la vista",
    noneInView: "No hay cimas por encima de {m} m en la vista",
    emptyTitle: "Aún no tienes listas",
    create: "Crear lista",
    editList: "Editar lista",
    editHint: "Toca una lista para cambiar su nombre o su descripción.",
    optional: "Opcional",
    noItems: "Sin cimas",
    deleteNamed: "Eliminar {name}",
    editNamed: "Editar {name}",
    moveUpNamed: "Subir {name}",
    moveDownNamed: "Bajar {name}",
    peakCount: "{n} cimas",
    peakCountOne: "1 cima",
    remaining: "Faltan {n}",
    remainingOne: "Falta 1",
    complete: "Lista completada",
    viewStamps: "Ver sellos",
    viewMode: "Vista",
    statusFilter: "Estado",
    sort: "Ordenar",
    sortedBy: "Ordenar por {sort}",
    sortNeedsLocation: "Usa tu ubicación",
    findPeaks: "Buscar cimas",
    emptyItemsTitle: "Esta lista no tiene cimas",
    emptyItemsBody: "Añádelas desde el catálogo, el mapa o un archivo CSV o GPX.",
    noneDoneTitle: "Ninguna completada todavía",
    noneDoneBody: "Las cimas de esta lista que subas aparecerán aquí.",
    nonePendingTitle: "No quedan cimas pendientes",
    nonePendingBody: "Has subido todas las cimas de esta lista.",
    notFound: "Lista no encontrada",
    noSeason: "Sin temporada",
    climbedOn: "Ascendida el {date}",
    addMode: "Cómo añadir",
    modeSearch: "Buscar",
    modeMap: "Mapa",
    modeImport: "Importar",
    liveHint: "Cimas que no están en el catálogo",
    mapHint: "Acerca el mapa y toca una cima para añadirla a la lista.",
    findInView: "Buscar en la vista",
    chooseFile: "Elegir archivo",
    unmatched: "Sin emparejar",
    addedOne: "1 cima añadida",
    addOnePeak: "Añadir 1 cima",
  },
  live: {
    title: "Búsqueda en línea",
    placeholder: "Nombre de la cima",
    help: "Busca en OpenStreetMap y Wikidata cimas que no están en tu catálogo local. Pulsa Buscar (no se busca mientras escribes).",
    sourceNominatim: "OpenStreetMap (Nominatim)",
    sourceWikidata: "Wikidata",
    sourceOverpass: "OpenStreetMap (vista del mapa)",
    noResults: "Sin resultados",
    inCatalog: "En tu catálogo",
    importing: "Añadiendo…",
    needsOnline: "La búsqueda en línea necesita conexión.",
    source: "Fuente",
    sourceOsm: "OpenStreetMap",
    noResultsBody: "Prueba con otro nombre o cambia de fuente.",
  },
  bucket: {
    name: "Bucket list",
    count: "{n} cimas por subir",
    countOne: "1 cima por subir",
    empty: "Tus próximas cimas",
    emptyTitle: "Tu bucket list está vacía",
    emptyBody: "Guarda aquí las cimas que sueñas subir. Al subir una sale de la lista, y su sello pasa a tu pasaporte.",
    footer: "Al registrar una ascensión, la cima sale de la lista y su sello pasa a tu pasaporte.",
    climbed: "Ya la has subido",
    added: "Añadida a tu bucket list",
    badge: "Bucket list",
    left: "{name} sale de tu bucket list",
    leftMany: "{n} cimas salen de tu bucket list",
    stamps: "Sus sellos por conseguir",
    next: "La próxima: {name}",
  },
  explore: {
    title: "Explorar",
    sections: "Secciones",
    all: "Todo",
    collections: "Colecciones",
    summits: "Cumbres",
    ascents: "Ascensiones",
    search: "Busca una cima",
    searchTitle: "Buscar una cima",
    searchHint: "Busca entre las cimas del Pirineo y las tuyas, también sin cobertura.",
    ranges: "Tus cordilleras",
    notebook: "Tu cuaderno",
    featured: "Colecciones destacadas",
    yourLists: "Tus listas",
    recent: "Últimas ascensiones",
    seeAll: "Ver todo",
    passport: "Pasaporte",
    passportEmpty: "Tu primer sello te espera",
    progress: "{done} de {total}",
    complete: "Completada",
    featuredShort: "Destacadas",
  },
  summits: {
    title: "Cumbres",
    subtitle: "{n} cimas en {r} cordilleras",
    subtitleOne: "{n} cimas en 1 cordillera",
    subtitleOnlyOne: "1 cima en 1 cordillera",
    emptyTitle: "Tus cumbres aparecerán aquí",
    emptyBody: "Cada cima que subas se suma a su cordillera, con su sello.",
    toStart: "Por estrenar",
    toStartHint: "Cordilleras con cimas en tus listas que aún no has pisado.",
    climbed: "Ascendidas",
    pending: "Pendientes",
    highest: "La más alta",
    upTo: "hasta {m}",
    range: "Cordillera",
    first: "Primera",
    inLists: "{done} de {total} en tus listas",
    climbedCount: "{n} ascendidas",
    climbedCountOne: "1 ascendida",
    noneClimbedTitle: "Aún no has subido ninguna",
    noneClimbedBody: "Las cimas de esta cordillera que subas aparecerán aquí con su sello.",
    nonePendingTitle: "Nada pendiente aquí",
    nonePendingBody: "No quedan cimas de tus listas por subir en esta cordillera.",
    notFound: "Cordillera no encontrada",
    stampsOf: "Sellos de {name}",
    other: "Otras",
  },
  passport: {
    title: "Pasaporte",
    empty: "Tu pasaporte está vacío. Cada cima que subas añadirá un sello.",
    filterByList: "Filtrar por lista",
    allStamps: "Todos mis sellos",
    counter: "{done} / {total}",
    locked: "Pendiente",
    stamps: "{n} sellos",
    stampsOne: "1 sello",
    emptyTitle: "Aún no tienes sellos",
    emptyBody: "Cada cima que subas añadirá un sello a tu pasaporte.",
    listEmptyTitle: "Esta lista no tiene cimas",
    listEmptyBody: "Añade cimas a la lista para ver aquí sus sellos.",
    toGo: "{n} sellos por conseguir",
    toGoOne: "1 sello por conseguir",
    allDone: "Todos los sellos conseguidos",
    view: "Vista",
    viewGrid: "Ordenado",
    viewBook: "Pasaporte",
    pageHead: "Sellos",
    pageOf: "Página {n} de {total}",
    pagesOf: "Páginas {a}–{b} de {total}",
    pageLabel: "Página {n} de {total}, {range}",
    pageFoot: "Este pasaporte contiene {n} páginas.",
    pageFootOne: "Este pasaporte contiene 1 página.",
    prevPage: "Página anterior",
    nextPage: "Página siguiente",
    cover: "Pasaporte de cumbres",
    coverSince: "Desde {year}",
    bookEmptyTitle: "Aún no hay sellos de esta lista",
    bookEmptyBody: "Cámbiala a Ordenado para ver los que te faltan.",
  },
  avatar: {
    title: "Foto de perfil",
    subtitle: "Se guarda recortada a 512 px, sin la ubicación ni los datos de la cámara.",
    cropHint: "Arrastra para encuadrar, pellizca o usa el control para ampliar.",
    choose: "Elegir foto",
    change: "Cambiar foto",
    remove: "Quitar foto",
    use: "Usar foto",
    zoom: "Zoom",
    saved: "Foto actualizada",
    openError: "No se pudo abrir esa imagen",
    saveError: "No se pudo preparar la foto",
    edit: "Cambiar foto de perfil",
  },
  profile: {
    title: "Tú",
    cover: "Pasaporte de cimas",
    peaks: "cimas",
    peakOne: "cima",
    since: "Desde {date}",
    ascents: "Ascensiones",
    ascentsLower: "ascensiones",
    ascentOne: "ascensión",
    gain: "Desnivel",
    threeThousanders: "Tresmiles",
    pinned: "Sellos destacados",
    pinnedEdit: "Elegir",
    pinnedAdd: "Destacar un sello",
    pinnedHint: "Elige hasta {n} sellos de los que estés orgulloso.",
    pinPicker: "Sellos destacados",
    pinPickerSubtitle: "Elige hasta {n}. Aparecen en tu perfil y en la imagen para compartir.",
    pinSearch: "Buscar entre tus cimas",
    pinFull: "Ya tienes {n} sellos destacados. Quita uno para elegir otro.",
    pinNoResults: "Ninguna cima coincide",
    pinOrder: "Destacado {n}",
    thisYear: "Este año",
    yearAscents: "Ascensiones",
    yearNewPeaks: "Cimas nuevas",
    yearGain: "Desnivel",
    yearHighest: "La más alta",
    yearEmpty: "Aún no has subido nada en {year}",
    yearEmptyBody: "La próxima cima abre la temporada.",
    vsMore: "{n} más que en {year}",
    vsMoreOne: "1 más que en {year}",
    vsLess: "{n} menos que en {year}",
    vsLessOne: "1 menos que en {year}",
    vsSame: "Las mismas que en {year}",
    perMonth: "Ascensiones por mes",
    zones: "Zonas",
    zonesCount: "{n} macizos",
    zonesCountOne: "1 macizo",
    zoneProgress: "{done} de {total} cimas",
    zonesMore: "Ver todas",
    zonesLess: "Ver menos",
    facts: "Curiosidades",
    factEverest: "Everest",
    factEverestLabel: "de desnivel acumulado, {m}",
    factStreak: "meses seguidos",
    factStreakLabel: "subiendo alguna cima, tu mejor racha",
    factWeeks: "semanas",
    factWeeksOne: "semana",
    factWeeksLabel: "seguidas con alguna cima",
    factWeeksLabelOne: "seguida con alguna cima",
    factWeeksRefugio: "seguidas, con {n} semanas de refugio guardadas",
    factWeeksRefugioOne: "seguidas, con 1 semana de refugio guardada",
    factWeeksSpent: "seguidas. Semana de refugio: el monte sigue ahí",
    factWeeksPaused: "seguidas, ahora en pausa",
    factWeeksPausedOne: "seguida, ahora en pausa",
    factWeeksBestLabel: "tu mejor racha de semanas con alguna cima",
    factFavorite: "veces",
    factFavoriteLabel: "en {name}, tu cima favorita",
    factBigDay: "cimas",
    factBigDayLabel: "en una sola salida, el {date}",
    factSpan: "km",
    factSpanLabel: "de cordillera, de {west} a {east}",
    factWinter: "invernales",
    factWinterLabel: "ascensiones en invierno",
    factWinterOne: "invernal",
    factWinterLabelOne: "ascensión en invierno",
    factMonthLabel: "{n} ascensiones en {month}, más que en ningún otro",
    factTresmiles: "de {total}",
    factTresmilesLabel: "tresmiles del Pirineo",
    factFirst: "Tu primera cima",
    factFirstLabel: "{name}, el {date}",
    seeStats: "Todas las estadísticas",
    emptyTitle: "Tu perfil empieza en la primera cima",
    emptyBody: "Registra una ascensión con el botón + y aquí verás tus sellos destacados y tus curiosidades.",
    share: "Compartir resumen",
    shareTitle: "Compartir resumen",
    shareSubtitle: "Formato historia de Instagram",
    shareAll: "Todo",
    shareButton: "Compartir",
    shareDownload: "Guardar imagen",
    shareRendering: "Preparando la imagen…",
    shareError: "No se pudo crear la imagen",
    shareAlt: "Vista previa del resumen para compartir",
    storyKicker: "Mi pasaporte de cimas",
    storyKickerYear: "Mi {year} en la montaña",
    storyYearSub: "{n} nuevas en mi pasaporte",
    storyYearSubOne: "1 nueva en mi pasaporte",
    storyStamps: "Sellos destacados",
    storyStampsYear: "Lo más alto de {year}",
    storyFooter: "TopSummits",
    shareCordada: "Cordada",
    storyKickerCordada: "Mi cordada en {month}",
    storyCordadaEverest: "Everest",
    storyCordadaSummits: "cimas nuevas",
    storyCordadaSummitOne: "cima nueva",
    storyCordadaSub: "Entre todos, este mes",
    storyCordadaPeople: "Personas",
    storyCordadaNew: "Cimas nuevas",
    storyCordadaFooter: "Sígueme en TopSummits: @{handle}",
    metricAscents: "Ascensiones",
    metricAscentOne: "Ascensión",
    metricFollowers: "Seguidores",
    metricFollowerOne: "Seguidor",
    metricFollowing: "Siguiendo",
    metricPeaks: "Cimas",
    metricPeakOne: "Cima",
    metricsLabel: "{ascents}, {followers}, {following}",
    edit: "Editar perfil",
    shareShort: "Compartir",
    stampsTitle: "Pasaporte",
    stampsEmpty: "Tu primer sello llegará con tu primera cima.",
    rewardsEmpty: "Tus logros y las insignias de los retos saldrán aquí.",
    latest: "Últimas ascensiones",
    latestAll: "Ver todas",
    onlyYou: "Solo tú lo ves",
    onlyYouFooter: "Tus zonas y curiosidades cuentan todas tus ascensiones, también las que son solo para ti.",
    viewAs: "Ver cómo te ven",
    viewAsSubtitle: "Tu perfil tal como lo ve tu gente",
    private: "Solo para mí",
    followersOpen: "Ver tus seguidores",
    followingOpen: "Ver a quién sigues",
  },
  groups: {
    with1: "Con {a}",
    with2: "Con {a} y {b}",
    withMore: "Con {a}, {b} y {n} más",
    withMoreOne: "Con {a}, {b} y 1 más",
    withYou: "Contigo",
    withYou1: "Contigo y con {a}",
    withYouMore: "Contigo, con {a} y {n} más",
    withYouMoreOne: "Contigo, con {a} y 1 más",
    title: "Con quién",
    section: "En grupo",
    sectionBody: "Cada uno tiene su propia copia, con sus piedras y sus comentarios.",
    invite: "Invitar",
    inviteMore: "Invitar a más gente",
    sheetTitle: "Invitar a la ascensión",
    sheetSubtitle: "Si aceptan, la ascensión también será suya: el sello en su pasaporte y todo lo demás.",
    search: "Buscar entre tu gente",
    noPeople: "Aquí estará la gente que sigues y la que te sigue.",
    noMatches: "Nadie con ese nombre",
    footer: "Les llegará una invitación. Si la aceptan, también será suya, y si la borran, solo se borra la suya.",
    customOnly: "Las cimas propias no se comparten: añade una cima del catálogo para invitar.",
    member: "En el grupo",
    invited: "Invitación enviada",
    selected: "Se invitará al guardar",
    remove: "Quitar a {name}",
    withdrawConfirm: "¿Retirar la invitación a {name}?",
    sent: "Guardada. Invitación enviada a {name}",
    sentMany: "Guardada. {n} invitaciones enviadas",
    invitesTitle: "Te han invitado",
    invitedBy: "{name} te ha invitado a su ascensión",
    alreadyIn: "Ya están {names}",
    accept: "Aceptar",
    decline: "Rechazar",
    accepted: "Añadida a tus ascensiones",
    linked: "Unida a tu ascensión del {date}",
    declined: "Invitación rechazada. No se le avisa.",
    seeAll: "Ver todas",
    ownCopy: "Su ascensión",
    yourCopy: "Tu ascensión",
    waiting: "Invitación enviada a {names}",
  },
  friends: {
    title: "Amigos",
    sections: "Secciones de Amigos",
    activity: "Actividad",
    challenges: "Retos",
    boards: "Clasificación",
    people: "Personas",
    optInTitle: "Comparte tu pasaporte con tus amigos",
    optInBody: "Sigue a quien sube contigo, mira sus sellos y apúntate a retos.",
    optInPreview: "Así te verán",
    optInAction: "Activar perfil social",
    optInPrivate: "Tu cuenta sigue privada hasta que lo actives.",
    search: "Buscar por @usuario",
    searchHint: "Escribe al menos 3 letras de su usuario.",
    searchOffline: "Buscar personas necesita conexión.",
    searchEmpty: "Nadie con ese usuario",
    searchFailed: "No se ha podido buscar. Vuelve a probar.",
    requests: "Solicitudes",
    following: "Siguiendo",
    followers: "Seguidores",
    accept: "Aceptar",
    deny: "Rechazar",
    remove: "Quitar",
    removeConfirm: "¿Quitar a {name} de tus seguidores? No se le avisa.",
    unfollowConfirm: "¿Dejar de seguir a {name}?",
    cancelRequestConfirm: "¿Cancelar la solicitud a {name}?",
    pending: "Solicitud enviada",
    emptyTitle: "Aún no sigues a nadie",
    emptyBody: "Busca a tus amigos por su usuario o compárteles el tuyo.",
    invite: "Invitar amigos",
    inviteSubtitle: "Comparte el enlace a tu perfil",
    inviteText: "Sígueme en TopSummits",
    linkCopied: "Enlace copiado",
  },
  social: {
    follow: "Seguir",
    requested: "Solicitado",
    following: "Siguiendo",
    followsYou: "Te sigue",
    followers: "{n} seguidores",
    followersOne: "1 seguidor",
    followingCount: "{n} siguiendo",
    privateTitle: "Perfil privado",
    privateBody: "Perfil privado. Cuando te acepte verás su pasaporte.",
    privateHint: "Cuando te acepte verás su pasaporte.",
    unavailableTitle: "Perfil no disponible",
    unavailableBody: "Esta persona no existe o no puedes ver su perfil.",
    offlineBody: "Necesitas conexión para abrir un perfil que no has visto antes.",
    menu: "Más opciones",
    share: "Compartir perfil",
    block: "Bloquear",
    unblock: "Desbloquear",
    blockConfirm: "¿Bloquear a {name}? Dejaréis de veros y de seguiros. No se le avisa.",
    blockedToast: "{name} bloqueado",
    report: "Reportar",
    reportTitle: "Reportar a {name}",
    reportSubtitle: "Lo leerá quien mantiene TopSummits. No se le avisa.",
    reportReason: "Motivo",
    reasons: { spam: "Spam", offensive: "Contenido ofensivo", impersonation: "Se hace pasar por otra persona", minor_safety: "Pone en riesgo a un menor", other: "Otro motivo" },
    reportNote: "Detalles (opcional)",
    reportSend: "Enviar reporte",
    reportSent: "Reporte enviado. Gracias por avisar.",
    yourProfile: "Tu perfil social",
    editSocial: "Editar perfil social",
    pinned: "Sellos destacados",
    stamps: "Sellos",
    stampsCount: "{n} sellos",
    stampsCountOne: "1 sello",
    seePassport: "Ver su pasaporte",
    passportTitle: "Pasaporte de {name}",
    passport: "Pasaporte",
    passportEmpty: "Aún no tiene sellos",
    customPeak: "Cima propia",
    logros: "Logros",
    insignias: "Insignias",
    streak: "Racha",
    thisYear: "Este año",
    yearAscents: "Ascensiones",
    yearNewPeaks: "Cimas nuevas",
    yearGain: "Desnivel",
    lists: "Listas",
    listProgress: "{done} de {total}",
    latest: "Últimas ascensiones",
    latestEmpty: "Aún no hay ascensiones que ver.",
    newStamp: "Primera vez",
    newPeak: "Cima nueva",
    newPeaks: "{n} cimas nuevas",
    withTrack: "con track",
    withPhoto: "con foto",
    compareRow: "Comparar",
    compareMissing: "Te faltan {n} cimas de {name}",
    compareMissingOne: "Te falta 1 cima de {name}",
    compareSubtitle: "Las cimas en común y las que os faltan",
    compareTitle: "Comparar",
    both: "En común",
    mineMissing: "Te faltan",
    theirsMissing: "Le faltan",
    compareAll: "Todas",
    compareEmpty: "Nada por aquí",
    compareMissingOf: "Te faltan {n} cimas de {name}",
    compareMissingOfOne: "Te falta 1 cima de {name}",
    you: "Tú",
    addToBucket: "Añadir a mi Bucket list",
    addToBucketCount: "Añadir {n} a mi Bucket list",
    addedToBucket: "Añadidas a tu Bucket list",
    addedToBucketOne: "Añadida a tu Bucket list",
    select: "Seleccionar",
    logro: {
      first: "Primera cima",
      tresmil: "Primer tresmil",
      summits: "{n} cimas",
      list: "{name} completada",
      streak: "{n} semanas seguidas",
      huellas: "{n} huellas",
    },
  },
  socialSettings: {
    title: "Perfil social",
    row: "Perfil social y privacidad",
    rowOff: "Desactivado",
    activateTitle: "Activa tu perfil social",
    activateBody: "Elige tu usuario y quién puede ver tu pasaporte. Puedes cambiarlo o desactivarlo cuando quieras.",
    activate: "Activar perfil social",
    activated: "Perfil social activado",
    saved: "Perfil social guardado",
    profile: "Perfil",
    name: "Nombre",
    nameFooter: "Tu nombre se verá junto a tu usuario.",
    handle: "Usuario",
    handlePlaceholder: "tu_usuario",
    handleRules: "De 3 a 20 letras, números, _ o . y empieza por una letra.",
    handleChecking: "Comprobando…",
    handleAvailable: "Disponible",
    handleTaken: "No disponible",
    handleOffline: "Elegir usuario necesita conexión.",
    handleCooldown: "Podrás cambiarlo de nuevo el {date}.",
    bio: "Bio",
    bioPlaceholder: "Qué montañas te gustan, desde dónde sales…",
    zone: "Zona",
    zoneNone: "Ninguna",
    zoneFooter: "Una cordillera, nunca un pueblo. Solo la ven tus seguidores.",
    audience: "Quién puede ver tu pasaporte",
    audienceFollowers: "Seguidores que apruebas",
    audienceMembers: "Cualquiera con cuenta",
    audienceFooter: "Tu nombre, usuario, foto y bio los ve cualquiera con cuenta. Tus ascensiones, solo quien elijas aquí.",
    audienceMinor: "Por tu edad, solo tus seguidores aprobados pueden ver tu pasaporte, y tus ascensiones se publican al día siguiente.",
    publish: "Publicar ascensiones",
    publishNextDay: "Al día siguiente",
    publishNow: "Al momento",
    publishFooter: "Al día siguiente, nadie sabe que estás en el monte mientras estás en él.",
    boards: "Aparecer en clasificaciones",
    boardsFooter: "Si lo quitas, sigues viendo tus números y nadie más te ve en ellas.",
    comments: "Comentarios",
    commentsAudience: "Quien ve la ascensión",
    commentsNobody: "Nadie",
    blocked: "Bloqueados",
    blockedEmpty: "No has bloqueado a nadie.",
    deactivate: "Desactivar perfil social",
    deleteComments: "Borrar también mis comentarios",
    deleteCommentsFooter: "Si no, tus comentarios en ascensiones de otros se quedan.",
    deactivateConfirm: "Tu perfil y tus ascensiones dejarán de verse al momento. Tus seguidores y a quién sigues se guardan por si vuelves.",
    deactivated: "Perfil social desactivado",
    textNotAllowed: "Ese texto no está permitido",
    failed: "No se ha podido guardar: {reason}",
    onlyMe: "Solo para mí",
    onlyMeFooter: "No aparece en Amigos ni en clasificaciones.",
    streak: "Racha",
    pause: "Pausar racha",
    pauseTitle: "Pausar la racha",
    pauseBody: "Una lesión, la temporada baja: las semanas en pausa no rompen la racha ni suman. Se levanta sola si registras una ascensión.",
    pauseWeeks: "{n} semanas",
    pauseWeeksOne: "1 semana",
    pauseLeft: "Te quedan {n} semanas de pausa este año.",
    pauseLeftOne: "Te queda 1 semana de pausa este año.",
    pauseNone: "Ya has usado las {n} semanas de pausa de este año.",
    pausedUntil: "En pausa hasta el {date}",
    resume: "Reanudar ahora",
  },
  notices: {
    title: "Avisos",
    open: "Avisos",
    unread: "{n} avisos sin leer",
    emptyTitle: "Sin avisos",
    emptyBody: "Aquí verás quién te sigue, las solicitudes y lo que pasa con tus cimas.",
    today: "Hoy",
    yesterday: "Ayer",
    followRequest: "{name} quiere seguirte",
    follow: "{name} te sigue",
    accepted: "{name} ha aceptado tu solicitud",
    piedra: "{name} ha puesto una piedra en tu {peak}",
    comment: "{name} ha comentado tu ascensión a {peak}",
    commentNoPeak: "{name} ha comentado tu ascensión",
    huella: "{name} ha seguido tu huella en {peak}",
    logro: "Nuevo logro: {logro}",
    yourAscent: "ascensión",
    piedraMore: "{name} y {n} más han puesto una piedra en tu {peak}",
    piedraMoreOne: "{name} y 1 más han puesto una piedra en tu {peak}",
    reply: "{name} también ha comentado la ascensión de {owner} a {peak}",
    replyNoPeak: "{name} también ha comentado la ascensión de {owner}",
    replyOwner: "{name} ha respondido en su ascensión a {peak}",
    replyOwnerNoPeak: "{name} ha respondido en su ascensión",
    invite: "{name} te ha invitado a su ascensión a {peak}",
    inviteNoPeak: "{name} te ha invitado a una ascensión",
    joined: "{name} se ha unido a tu ascensión a {peak}",
    joinedNoPeak: "{name} se ha unido a tu ascensión",
  },
  push: {
    welcomeTitle: "Avisos activados",
    welcomeBody: "Así te avisaremos de lo que pase con tus cimas.",
    insignia: "Has ganado una insignia nueva.",
    cardTitle: "Avisos en el móvil",
    cardBody: "Te avisamos cuando alguien quiere seguirte, pone una piedra o comenta, aunque la app esté cerrada.",
    enable: "Activar avisos",
    later: "Ahora no",
    installTitle: "Añade TopSummits a tu pantalla de inicio",
    installBody: "En iPhone, los avisos llegan a la app de la pantalla de inicio: Compartir, Añadir a pantalla de inicio.",
    deniedTitle: "Avisos bloqueados",
    deniedBody: "Este dispositivo los tiene bloqueados para TopSummits. En iPhone se activan en Ajustes, Notificaciones, TopSummits.",
    settings: "Ajustes de avisos",
    settingsTitle: "Avisos en el móvil",
    on: "Activados en este dispositivo",
    off: "Desactivados en este dispositivo",
    disable: "Desactivar en este dispositivo",
    categories: "Qué te avisamos",
    categoriesFooter: "En todos tus dispositivos. En Avisos lo sigues viendo todo.",
    category: {
      follows: "Seguidores y solicitudes",
      piedras: "Piedras",
      comments: "Comentarios",
      huellas: "Huellas",
      logros: "Logros y retos",
      invites: "Invitaciones a ascensiones",
    },
    failed: "No se han podido activar los avisos.",
    offline: "Activar los avisos necesita conexión.",
  },
  ascent: {
    unavailableBody: "Puede que ya no puedas verla o que se haya borrado.",
    failed: "No se ha podido cargar la ascensión.",
    offline: "Esta ascensión necesita conexión la primera vez.",
    seeProfile: "Ver el perfil de {name}",
    seeMine: "Ver en mis ascensiones",
    report: "Reportar ascensión",
    waiting: "Tus amigos la verán {when}.",
    peaks: "{n} cimas",
    peaksOne: "Cima",
    piedras: "Piedras",
    piedrasNone: "Aún nadie ha puesto una piedra.",
    piedrasNoneMine: "Cuando alguien ponga una piedra en tu cima, saldrá aquí.",
    piedraPut: "Has puesto una piedra",
  },
  challenges: {
    title: {
      gain: "Desnivel de {month}",
      new: "Cimas nuevas de {month}",
      zones: "Explorador de {month}",
      huellas: "Tras sus huellas en {month}",
    },
    body: {
      gain: "Suma {target} de desnivel este mes.",
      new: "Estrena {target} cimas que aún no estén en tu pasaporte.",
      zones: "Sube cimas en {target} zonas distintas: valles y macizos del Pirineo, o cordilleras.",
      huellas: "Estrena {target} cimas que ya haya subido alguien a quien sigues.",
    },
    progress: {
      gain: "{n} de {target} m",
      new: "{n} de {target} cimas",
      zones: "{n} de {target} zonas",
      huellas: "{n} de {target} huellas",
    },
    join: "Apuntarme",
    joined: "Apuntado",
    done: "Conseguido",
    leave: "Dejar el reto",
    leaveConfirm: "¿Dejar el reto? Si vuelves, tu progreso del mes sigue contando.",
    participants: "{n} personas apuntadas",
    participantsOne: "1 persona apuntada",
    participantsNone: "Aún no se ha apuntado nadie",
    daysLeft: "Quedan {n} días",
    daysLeftOne: "Queda 1 día",
    lastDay: "Último día",
    friends: "Gente que sigues",
    friendsNone: "Nadie a quien sigues se ha apuntado todavía.",
    yours: "Tu progreso",
    note: "Cuentan tus ascensiones del mes que no son \"Solo para mí\". Tus amigos ven tu progreso cuando se publican. Cada reto conseguido te da su insignia.",
    logro: "Reto conseguido: {name}",
    monthTitle: "Retos de {month}",
    madeOf: "de {total} conseguidos",
    insigniasCount: "{n} insignias",
    insigniasCountOne: "1 insignia",
    insigniasNone: "Tus insignias",
    doneOn: "Conseguido el {date}",
    reward: "Recompensa",
    rewardBody: "Su medalla, con el mes grabado. Se queda para siempre en tus insignias y se ve en tu perfil.",
    rewardDone: "Insignia ganada el {date}. Está en tus insignias y en tu perfil.",
    seeInsignias: "Ver mis insignias",
    earnedKicker: "Reto conseguido",
    earnedBody: "Su medalla ya está en tus insignias. La verá en tu perfil la gente que te sigue.",
    insignias: "Tus insignias",
    insigniasEmpty: "Consigue un reto para ganar tu primera insignia.",
    insignia: "Insignia: {name}",
    insigniaLocked: "Insignia por conseguir: {name}",
    medal: { gain: "Desnivel", new: "Cimas nuevas", zones: "Explorador", huellas: "Tras sus huellas" },
    hidden: "No apareces en las clasificaciones: la gente que sigues no ve tu progreso.",
    failed: "No se han podido cargar los retos.",
    offline: "Los retos necesitan conexión la primera vez.",
  },
  loops: {
    dismiss: "Ocultar",
    weekTitle: "Tu semana",
    weekRange: "Del {from} al {to}",
    weekAscents: "{n} ascensiones",
    weekAscentsOne: "1 ascensión",
    weekNew: "{n} cimas nuevas",
    weekNewOne: "1 cima nueva",
    weekQuiet: "Una semana tranquila. El monte sigue ahí.",
    weekStreak: "{n} semanas seguidas",
    weekStreakOne: "1 semana seguida",
    yearTitle: "Tu año en el monte",
    yearBody: "{ascents} y {peaks} en {year}.",
    yearOpen: "Ver tu año",
  },
  feed: {
    emptyTitle: "Sigue a alguien para ver sus cimas aquí",
    emptyBody: "Cuando la gente que sigues publique una ascensión, la verás en Actividad.",
    quietTitle: "Sin ascensiones recientes",
    quietBody: "La gente que sigues no ha publicado nada en los últimos meses.",
    findPeople: "Buscar personas",
    more: "Ver más",
    todayAt: "hoy a las {time}",
    tomorrowAt: "mañana a las {time}",
    elevation: "Altitud",
    gain: "Desnivel",
    distance: "Distancia",
    waiting: "Tus amigos la verán {when}",
    open: "Ver la ascensión de {name}: {peaks}",
    aloneTitle: "Aquí verás también a tu gente",
    aloneBody: "Sigue a quien sube contigo y verás sus cimas junto a las tuyas.",
    failed: "No se ha podido cargar la actividad.",
    offline: "La actividad necesita conexión la primera vez.",
    listLine: "{name}: {done} de {total}",
    piedra: "Poner una piedra",
    piedraOn: "Quitar tu piedra",
    piedras: "{n} piedras",
    piedrasOne: "1 piedra",
    comments: "{n} comentarios",
    commentsOne: "1 comentario",
    commentsOpen: "Comentarios",
    title: "Comentarios",
    empty: "Aún no hay comentarios.",
    closed: "Los comentarios están cerrados.",
    tooNew: "Podrás comentar cuando tu cuenta cumpla un día.",
    socialOff: "Activa tu perfil social para comentar.",
    unavailable: "Esta ascensión ya no está disponible.",
    placeholder: "Escribe un comentario",
    send: "Enviar",
    pending: "Pendiente de enviar",
    menu: "Opciones del comentario",
    remove: "Borrar comentario",
    removeConfirm: "¿Borrar este comentario?",
    report: "Reportar comentario",
  },
  boards: {
    title: "Clasificación",
    new: "Cimas nuevas",
    weeks: "Semanas activas",
    weeksChip: "Semanas",
    gain: "Desnivel",
    lists: "Listas",
    huellas: "Huellas",
    metrics: "Qué se cuenta",
    periods: "Periodo",
    week: "Semana",
    month: "Mes",
    year: "Año",
    thisYear: "Este año",
    allTime: "Siempre",
    provisional: "Provisional",
    gainNote: "Solo lo que registras, hasta {m} por ascensión.",
    weeksNote: "Semanas con alguna cima: cada una cuenta en el mes de su jueves.",
    huellasNote: "Una huella cuando alguien que sigues sube una cima que tú subiste antes.",
    listNote: "Las cimas de la lista que tiene cada uno, desde siempre.",
    zeroWeek: "Aún sin cimas esta semana",
    zeroMonth: "Aún sin cimas este mes",
    zeroYear: "Aún sin cimas este año",
    zeroAll: "Aún sin cimas de la lista",
    zeroWeeks: "Aún sin semanas con cima",
    zeroGain: "Aún sin desnivel",
    zeroHuellas: "Aún sin huellas",
    you: "Tú",
    card: "Tu semana",
    cardNew: "{n} cimas nuevas",
    cardNewOne: "1 cima nueva",
    cardNewNone: "Sin cimas nuevas por ahora",
    bestWeek: "Tu mejor semana: {n} cimas nuevas",
    bestWeekOne: "Tu mejor semana: 1 cima nueva",
    cordada: "Cordada",
    cordadaOf: "Cordada de {month}",
    everest: "Everest",
    cordadaTogether: "Entre todos, este mes",
    newSummits: "Cimas nuevas",
    people: "En la cordada",
    listsTitle: "Colecciones",
    listsSubtitle: "Quién tiene más cimas de cada una, desde siempre.",
    podiumValue: "{n} de {total}",
    podiumSr: "{n} cimas",
    podiumSrOne: "1 cima",
    cordadaTitle: "Entre todos, {n} Everest este mes",
    cordadaEmpty: "Este mes aún no hay desnivel entre todos",
    cordadaNext: "{m} para el siguiente",
    cordadaFirst: "{m} para el primero",
    cordadaMine: "Tu parte: {pct} % del desnivel ({m})",
    ofTotal: "de {total}",
    cordadaSummits: "{n} cimas nuevas entre todos",
    cordadaSummitsOne: "1 cima nueva entre todos",
    emptyTitle: "Sigue a alguien para compararos",
    emptyBody: "Las clasificaciones son entre la gente que sigues: un grupo pequeño en el que cualquiera puede ser primero.",
    findPeople: "Buscar personas",
    hidden: "No apareces en las clasificaciones. Tus números siguen aquí.",
    failed: "No se ha podido cargar la clasificación.",
    offline: "Esta clasificación necesita conexión la primera vez.",
    streakWeeks: "{n} semanas seguidas",
    streakWeeksOne: "1 semana seguida",
    refugio: "{n} semanas de refugio guardadas",
    refugioOne: "1 semana de refugio guardada",
    refugioSpent: "Semana de refugio: el monte sigue ahí",
    bestStreak: "Tu mejor racha: {n} semanas",
    bestStreakOne: "Tu mejor racha: 1 semana",
    paused: "Racha en pausa",
  },
  settings: {
    title: "Ajustes",
    sync: "Sincronización",
    syncNow: "Sincronizar",
    syncing: "Sincronizando…",
    pending: "{n} cambios pendientes",
    pendingOne: "1 cambio pendiente",
    synced: "Todo sincronizado",
    lastSync: "Última sincronización: {date}",
    failed: "{n} cambios con error",
    discardFailed: "Descartar cambios con error",
    retryFailed: "Reintentar",
    export: "Exportar datos",
    exportJson: "Todo (JSON)",
    exportCsv: "{name} (CSV)",
    exportTables: { ascents: "Ascensiones", peaks: "Cimas", lists: "Listas" },
    storage: "Almacenamiento",
    storageUsage: "{used} usados de {quota}",
    persisted: "Almacenamiento persistente activado",
    notPersisted: "El sistema podría borrar los datos sin conexión si falta espacio",
    version: "Versión",
    account: "Cuenta",
    signedInAs: "Sesión: {who}",
    logout: "Cerrar sesión",
    stats: "Estadísticas",
    attributions: "Datos y atribuciones",
    installHelp: "Instalar en el iPhone",
    clearCache: "Borrar caché local",
    clearCacheConfirm: "Se borrarán los datos guardados en este dispositivo (no los del servidor). Los cambios pendientes se perderán.",
    persistent: "Modo persistente",
    persistentDenied: "El sistema no ha permitido activarlo",
    notPersistedFooter: "Sin el modo persistente, el sistema podría borrar los datos sin conexión si falta espacio.",
    attributionPeaks: "Cimas: {osm}, {wikidata}",
    attributionMaps: "Mapas: IGN España (CC BY 4.0), OpenTopoMap (CC-BY-SA), IGN France / Géoplateforme (Licence Ouverte 2.0), relieve Mapterhorn.",
    modeStandalone: "App instalada",
    modeBrowser: "Navegador",
    ops: {
      ascent: "Ascensión",
      gpx: "Track GPX",
      list: "Lista",
      peak: "Cima",
      social: "Perfil social",
      follow: "Seguir",
      follower: "Seguidores",
      block: "Bloqueo",
      report: "Reporte",
      notices: "Avisos",
      piedra: "Piedra",
      comment: "Comentario",
      challenge: "Reto",
      pause: "Pausa de la racha",
      push: "Avisos en el móvil",
      invite: "Invitación a una ascensión",
    },
    failedOne: "1 cambio con error",
  },
  sync: {
    pending: "{n} pendientes",
    offline: "Sin conexión",
    syncing: "Sincronizando",
    synced: "Sincronizado",
    failed: "Error de sincronización",
  },
  session: {
    expired: "Sesión caducada",
    expiredBody: "Tu sesión ha caducado. Vuelve a entrar para seguir sincronizando. Tus cambios pendientes se conservan.",
  },
  login: {
    title: "Entrar",
    welcome: "Tu cuaderno de cimas",
    welcomeBody: "Entra con tu correo. Te enviaremos un código de 6 cifras; si es tu primera vez, se crea tu cuenta.",
    reauthTitle: "Vuelve a entrar",
    reauthBody: "Te enviaremos un código a {email}.",
    email: "Correo",
    emailPlaceholder: "tu@correo.com",
    send: "Enviar código",
    sending: "Enviando…",
    code: "Código",
    codeSent: "Hemos enviado un código a {email}. Caduca en 10 minutos.",
    verify: "Entrar",
    verifying: "Comprobando…",
    resend: "Enviar otro código",
    changeEmail: "Usar otro correo",
    offline: "Necesitas conexión para entrar.",
    badCode: "Código incorrecto o caducado.",
    tooMany: "Demasiados intentos. Espera un poco y vuelve a probar.",
    closed: "El registro está cerrado. Si ya tienes cuenta, usa su correo.",
    captcha: "No hemos podido comprobar que no eres un robot. Vuelve a probar.",
    failed: "No se ha podido entrar. Vuelve a probar.",
    otherAccount: "Hay {n} cambios sin sincronizar de otra cuenta en este dispositivo. Si entras con {email}, se descartarán.",
    legal: "Al crear una cuenta te pediremos que aceptes los términos y la política de privacidad.",
    or: "o",
    passkey: "Entrar con llave de acceso",
    passkeyFailed: "No se ha podido entrar con la llave de acceso.",
  },
  onboarding: {
    exit: "Salir",
    exitConfirm: "¿Salir sin terminar? Tu cuenta queda creada: la próxima vez que entres seguirás desde aquí.",
    back: "Atrás",
    continue: "Continuar",
    progress: "Paso {n} de {total}",
    nameTitle: "¿Cómo te llamas?",
    nameBody: "Así aparecerás en tu perfil y en las historias que compartas.",
    name: "Nombre",
    namePlaceholder: "Tu nombre",
    photoAdd: "Añadir foto",
    photoChange: "Cambiar foto",
    photoOptional: "Opcional",
    aboutTitle: "Sobre ti",
    aboutBody: "Para tu perfil y tus estadísticas. Solo lo ves tú.",
    birthYear: "Año de nacimiento",
    birthYearChoose: "Elegir",
    birthYearFooter: "Debes tener al menos {age} años. Solo guardamos el año.",
    sex: "Sexo",
    homeBase: "Zona",
    homeBasePlaceholder: "Ciudad o comarca",
    homeBaseFooter: "Desde dónde sueles salir al monte: Huesca, el Valle de Arán…",
    termsTitle: "Tus datos, tu cuenta",
    termsUpdatedTitle: "Hemos actualizado las condiciones",
    termsBody: "Antes de empezar, lo importante:",
    termsUpdatedBody: "Revísalas y acéptalas para seguir usando TopSummits.",
    termsUpdatedSocial: "Ahora puedes compartir tu pasaporte con amigos.",
    termsUpdatedPrivate: "Tu cuenta sigue privada hasta que lo actives.",
    pointPrivate: "Todo lo que registras es privado: nadie más lo ve.",
    pointControl: "Puedes exportar tus datos o eliminar tu cuenta cuando quieras, desde Ajustes.",
    pointEmail: "Solo te escribimos para enviarte códigos de acceso.",
    readTerms: "Términos y aviso legal",
    readPrivacy: "Política de privacidad",
    accept: "He leído y acepto los términos y la política de privacidad, y tengo al menos {age} años.",
    finish: "Crear mi perfil",
    finishUpdated: "Aceptar y continuar",
    saving: "Guardando…",
    offline: "Necesitas conexión para terminar.",
    tooYoung: "Debes tener al menos {age} años para usar TopSummits.",
    failed: "No se ha podido guardar. Vuelve a probar.",
    updating: "Hay una versión nueva de la app con estas condiciones. Actualizando…",
    doneTitle: "Todo listo, {name}",
    doneBody: "Registra tu primera ascensión y empieza a llenar tu pasaporte de sellos.",
    start: "Empezar",
  },
  sexes: { female: "Mujer", male: "Hombre", other: "Otro", undisclosed: "Prefiero no decirlo" },
  profileEdit: {
    row: "Perfil",
    title: "Tu perfil",
    save: "Guardar",
    saved: "Perfil guardado",
    age: "{n} años",
  },
  passkeys: {
    title: "Llaves de acceso",
    offerTitle: "¿Entrar con Face ID la próxima vez?",
    offerBody: "Guarda una llave de acceso en tu llavero de iCloud y entra sin esperar un código.",
    offerYes: "Crear llave de acceso",
    offerNo: "Ahora no",
    add: "Añadir llave de acceso",
    added: "Llave de acceso creada",
    empty: "Aún no tienes llaves de acceso.",
    footer: "Con una llave de acceso entras con Face ID o Touch ID. Se sincroniza con tu llavero de iCloud.",
    rename: "Renombrar",
    renamePrompt: "Nombre de la llave de acceso",
    delete: "Eliminar",
    deleteConfirm: "¿Eliminar la llave de acceso «{name}»? Podrás seguir entrando con un código.",
    unnamed: "Llave de acceso",
    created: "Creada el {date}",
    failed: "No se ha podido completar. Vuelve a probar.",
    defaultName: "iPhone",
  },
  account: {
    logoutAll: "Cerrar sesión en todos los dispositivos",
    logoutAllDone: "Sesiones cerradas en los demás dispositivos",
    delete: "Eliminar cuenta",
    deleteConfirm: "Se borrarán tu cuenta, tus ascensiones, listas, cimas propias y tracks. No se puede deshacer.",
    deleted: "Cuenta eliminada",
    needsOnline: "Necesitas conexión para esto.",
    unsyncedLogout: "Hay {n} cambios sin sincronizar. Si cierras sesión ahora se perderán.",
    failed: "No se ha podido completar. Vuelve a probar.",
    privacy: "Privacidad",
    terms: "Términos y aviso legal",
    support: "Ayuda y contacto",
  },
  update: {
    available: "Nueva versión disponible",
    reload: "Actualizar",
    later: "Más tarde",
  },
  install: {
    title: "Instala TopSummits",
    body: "Pulsa Compartir → Añadir a pantalla de inicio para usarla como una app, también sin cobertura.",
    ok: "Entendido",
  },
  storage: {
    quota: "No queda espacio en el dispositivo para guardar sin conexión. Libera espacio o sincroniza.",
  },
  attribution: {
    osm: "© OpenStreetMap contributors (ODbL)",
    wikidata: "Wikidata (CC0)",
    commons: "Imágenes: Wikimedia Commons (ver crédito en cada cima)",
    tresmiles: "Lista de tresmiles: Viquipèdia, CC BY-SA 4.0",
  },
  gpx: {
    track: "Track",
    distance: "{n} km",
    points: "{n} puntos",
  },
  photo: {
    section: "Foto",
    add: "Añadir foto",
    addHint: "La cima, la ruta o la cordada",
    footerShared: "La ven quienes pueden ver esta ascensión.",
    footerOnlyMe: "Solo la ves tú.",
    change: "Cambiar",
    remove: "Quitar",
    preparing: "Preparando la foto…",
    error: "No se pudo usar esa foto",
    tooSmall: "Esa foto es demasiado pequeña",
    uploading: "Subiendo",
    hidden: "Oculta tras reportes",
    hiddenBody: "Solo la ves tú hasta que se revise.",
    alt: "Foto de la ascensión a {name}",
    open: "Ver la foto",
    close: "Cerrar la foto",
    report: "Reportar foto",
    reportTitle: "Reportar la foto",
  },
  share: {
    title: "Compartir ascensión",
    subtitle: "Para tu historia, tu muro o como sticker sobre tu foto",
    open: "Compartir",
    template: "Diseño",
    templates: { photo: "Foto", track: "Track", stamp: "Sello" },
    format: "Formato",
    formats: { story: "Historia", post: "Publicación" },
    transparent: "Fondo transparente",
    transparentFooter: "Un sticker con tus datos para ponerlo encima de tu propia foto o vídeo.",
    share: "Compartir",
    save: "Guardar imagen",
    copy: "Copiar sticker",
    copied: "Sticker copiado",
    copyError: "No se pudo copiar el sticker",
    stickerHint: "En Instagram, crea una historia con tu foto de fondo y pega el sticker.",
    rendering: "Preparando la imagen…",
    error: "No se pudo crear la imagen",
    alt: "Imagen para compartir: {name}",
    first: "Primera ascensión",
    nth: "{n}.ª ascensión",
    more: "y {n} cimas más",
    moreOne: "y 1 cima más",
    passport: "Pasaporte de cimas",
  },
} as const;

export type Messages = typeof es;
